// Module for handling spectator login flows.
// Note: In SpaceDrake, the login_to_access modal has been disabled since
// SpaceDrake allows public access to information without requiring registration.
// The functions are maintained for compatibility with existing code.

import {page_params} from "./base_page_params.ts";

export function current_hash_as_next(): string {
    return `next=/${encodeURIComponent(window.location.hash)}`;
}

export function build_login_link(): string {
    let login_link = "/login/?" + current_hash_as_next();
    if (page_params.development_environment) {
        login_link = "/devlogin/?" + current_hash_as_next();
    }
    return login_link;
}

export let login_to_access = (empty_narrow?: boolean): void => {
    // SpaceDrake allows public access to information without requiring users to register.
    // This modal is disabled as it serves no purpose - spectators can view public content freely.
    // The function is kept as a no-op to maintain compatibility with existing code that calls it.
    void empty_narrow;
};

export function rewire_login_to_access(value: typeof login_to_access): void {
    login_to_access = value;
}
